<template>
    <div id="login" style="height:calc(100vh);">
        <div class="div_tcv w-90 h50 t-c bg-color-white r5 p10">
            <div class="col-12 mt10 mb20">
                <img src="../assets/cloud.gif" alt="" class="w-60">
            </div>
            <div class="col-12 f24 lh40 mb20">Bienvenido a Nube</div>
            
            <div class="col-12 mt5 mb5 mt20">
              <div class="col-12 mb10 b1 p5">
                  <form onsubmit="return false;">
                    <input type="text" class="bg-color-white lh30 w-100 t-c" placeholder="Usuario/Correo" v-model="user" ref="user" :class="{shaking:err}" @keydown="keydown_event($event)" autocomplete="on"> 
                  </form>
                </div>
                <div class="col-12 mb10 b1 p5">
                  <form onsubmit="return false;">
                    <input type="password" class="bg-color-white lh30 w-100 t-c" placeholder="Clave" v-model="password" ref="password" :class="{shaking:err}" @keydown="keydown_event($event)" autocomplete="on"> 
                  </form>
                </div>
                <div class="col-12 mb10">
                  <button class="bg-color-primary color-white w-100 lh40" @click="keydown_event(13)">Ingresar</button>
                </div>
                <div class="col-12 color-muted f14 lh26 color-info" @click="register()"> Crea tu cuenta </div>
                <div class="col-12 color-muted f14 lh26 color-muted"> Olvidaste tu clave </div>
                <!--
                <div class="col-12 mt20 t-c" @click="fingerprint()">
                  <i class="iconfont icon-kaoqin f50 color-muted"></i>
                </div>
                -->
            </div>
            <div class="col-12 t-c lh30 color2 mt5 f14"></div>
        </div>
        <div class="col-12 fixed-b t-c pb10 color2 f14">Versión: {{$store.state.set.app_ver}}</div>
        <div class="cover flex-c" v-if="modal">
            <div class="w30 h20 bg-color-white r10 t-c">
                <div class="col-12 h17 pt10">
                    <div class="mt20 mb20"><i class="iconfont icon-warning-filling f50 color-danger"></i></div>
                    <div class="color2 mt10">{{err_msg}}</div>
                </div>
                <button class="col-12 bg-color-primary lh35 color-white rbl10 rbr10" @click="keydown_event(27)"> Cerrar <span class="f14">[ESC]</span></button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'Login',
  data () {
    return {
      name:'',
      user:'',
      password: '',
      loader: false,
      modal: false,
      err: false,
      err_msg: '',
    }
  },
  created: function () {
    //console.log(window.PublicKeyCredential)
    //console.log(navigator.credentials)
  },
  methods: {
    register: function () {
      this.$router.push({name: "Register"});
    },
    fingerprint:function(){
      navigator.credentials.get({
        // 指定要获取的凭据类型
        password: true,
        // 指定要获取的凭据的域名
        domain: 'app.pos.com.ve'
      })
      .then(credential => {
        // 处理成功的凭据
        console.log(credential);
      })
      .catch(error => {
        // 处理错误的凭据
        console.error(error);
      });
    },
    keydown_event:function(event){
      var keyCode
      if(typeof(event) == "number"){
          keyCode = event
      }else{
          keyCode = event.keyCode
      }
      switch(keyCode) {
        case 13:
          this.err = false
          var password = this.password
          if(password.length < 3){
            this.$store.commit('setSound',true);
            this.err = true 
            this.$refs.user.select();
            return;
          }
          var post_data = {}
          post_data.login_type = 'manage';
          post_data.user = this.user;
          post_data.password = this.password;
          this.post(this.api_url + 'pub/login',post_data,true).then((res)=>{
              if(res.status == 1){
                this.$store.commit('setAccount',res.data);
                localStorage.setItem("token", res.token);
                this.$router.push({name: this.$store.state.app_type});
              }else{
                this.$store.commit('setSound','0.mp3');
                this.err = true;
              }
          })
          this.$refs.user.select();
        break;
      } 
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Login.vue